import React, { useState, useEffect } from "react";
import { getTriviaFileName, WEB_GENERATE_ERROR_MESSAGE } from "../data";
import { Button, Col, Popover, Row, PopoverBody } from "reactstrap";
import {
  BsDownload,
  BsHandThumbsDown,
  BsHandThumbsDownFill,
  BsHandThumbsUp,
  BsHandThumbsUpFill,
  BsThreeDots,
} from "react-icons/bs";
import LibraryQuestionGenerateModal from "./Components/LibraryQuestionGenerateModal";
import { contvertHTMLToPlain, Spinner } from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";
import ReactTooltip from "react-tooltip";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions";
import { orderBy } from "lodash";
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutDataLines,
  LayoutRowLines,
} from "../../../components/TableComponents/RowCardShadow/RowCardShadow";
import moment from "moment";
import {
  BiDownArrowAlt,
  BiEditAlt,
  BiTrashAlt,
  BiUpArrowAlt,
} from "react-icons/bi";
import { MdSchedule, MdOutlineAutoAwesome } from "react-icons/md";

import LibraryQuestionEditModal from "./Components/LibraryQuestionEditModal";
import DeleteQuestionModal from "./Components/DeleteQuestionModal";
import { toastContainer } from "../../../utils/toast";
import { connect } from "react-redux";
import ScheduleQuestionsModal from "./Components/ScheduleQuestionsModal";
import CheckBox from "rc-checkbox";
import { withRouter } from "react-router";
import If from "../../../components/Shared/If";
import { CSVLink } from "react-csv";
import SidebarComponent from "./Components/SidebarComponent";
import { isTime } from "validator";

function LibraryQuestions({
  library,
  sortParams,
  updateSortParams,
  user,
  updateLibraryQuestionCount,
  updateLibraryTrivvyCount,
  setLibQuestions,
  ...props
}) {
  const [questionGenerateModal, setQuestionGenerateModal] = useState(false);
  const [libraryQuestions, setLibraryQuestions] = useState([]);
  const [optionsPopoverOpen, setOptionsPopoverOpen] = useState(null);
  const [libQuestionEdit, setLibQuestionEdit] = useState(null);
  const [libQuestionDelete, setLibQuestionDelete] = useState(null);
  const [scheduleQuestionsModal, setScheduleQuestionsModal] = useState(false);
  const [hoveredQuestion, setHoveredQuestion] = useState(null);

  useEffect(() => {
    axios
      .get(url.getTriviaLibraryQuestions(library._id))
      .then(({ data }) => {
        setLibraryQuestions(data.data);
        setLibQuestions(data.data);
        updateLibraryQuestionCount({
          typeQuestion: "SET",
          valueQuestion: data.data.length,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const generateQuestionsApiCall = (payload) => {
    const apiCall = (cb) => {
      const loadingRows = Array(payload.questionsCount)
        .fill()
        .map((x, i) => ({
          loading: true,
          _id: "111",
          questionText: `Question ${i + 1}`,
        }));
      setLibraryQuestions([...loadingRows, ...libraryQuestions]);
      axios
        .post(url.generateQuestionsForLibrary, payload)
        .then(({ data }) => {
          let currentData = [...libraryQuestions];
          currentData = currentData.filter((x) => x._id !== "111");

          setLibraryQuestions([...data.data, ...currentData]);
          setLibQuestions([...data.data, ...currentData]);

          updateLibraryQuestionCount({
            typeQuestion: "INC",
            valueQuestion: data.data.length,
          });
        })
        .catch((error) => {
          console.log("ERRRR__OBJ", error);
          if (error.code === "ERR_NETWORK") {
            toastContainer(
              "Your questions are being generated, You can navigate away if you want.",
              "success"
            );
          } else {
            let errorMsg = WEB_GENERATE_ERROR_MESSAGE.replace(
              "trivvy",
              "questions"
            );
            if (
              error.response &&
              error.response.data &&
              error.response.data.errors &&
              error.response.data.errors.message
            ) {
              errorMsg = error.response.data.errors.message;
            }
            let currentData = [...libraryQuestions];
            currentData = currentData.filter((x) => x._id !== "111");

            setLibraryQuestions([...currentData]);
            setLibQuestions([...currentData]);

            toastContainer(errorMsg, "error");
          }
        });
    };
    setQuestionGenerateModal(false);
    if (payload.isGenerateFromAi) {
      apiCall();
    } else {
      apiCall();
    }
  };

  const onEditSuccess = (data) => {
    const questions = [...libraryQuestions];

    const index = questions.findIndex((x) => x._id == data._id);
    if (index >= 0) {
      questions[index] = data;

      setLibraryQuestions(questions);
    }
    setLibQuestionEdit(null);
  };

  const onDelete = (id) => {
    axios
      .delete(url.deleteLibraryQuestion(id))
      .then(({ data }) => {
        const newList = [...libraryQuestions].filter((x) => x._id != id);
        setLibraryQuestions([...newList]);
        setLibQuestions([...newList]);
        setLibQuestionDelete(null);
        updateLibraryQuestionCount({
          typeQuestion: "DEC",
          valueQuestion: 1,
        });
      })
      .catch((err) => {
        console.log(err);
        toastContainer("Error while deleting", "error");
      });
  };

  const changeSortField = (key, order) => {
    updateSortParams({
      sortBy: key,
      sortOrder: order,
    });
  };

  const sortComponent = (key) => {
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === "desc") {
        return (
          <BiDownArrowAlt
            size={"13px"}
            onClick={() => changeSortField(key, "asc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      } else {
        return (
          <BiUpArrowAlt
            size={"13px"}
            onClick={() => changeSortField(key, "desc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      }
    } else {
      return (
        <BiUpArrowAlt
          size={"13px"}
          onClick={() => changeSortField(key, "desc")}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      );
    }
  };

  const onScheduleSuccess = (newTrivvys) => {
    const data = [...libraryQuestions];

    updateLibraryTrivvyCount({
      typeTrivvy: "INC",
      valueTrivvy: newTrivvys.length,
    });

    axios
      .get(url.getTriviaLibraryQuestions(library._id))
      .then(({ data }) => {
        setLibQuestions(data.data);
        setLibraryQuestions(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setScheduleQuestionsModal(false);
  };

  const handleSortChange = (key, order) => {
    let libs = [...libraryQuestions];

    switch (key) {
      case "question":
        libs = orderBy(
          libs,
          (itm) => {
            const str = contvertHTMLToPlain(itm.questionText);

            return str.toLowerCase();
          },
          [order]
        );
        break;
      case "createdOn":
        libs = orderBy(libs, (itm) => itm.createdOn, [order]);
        break;
      case "triviaPart":
        libs = orderBy(libs, (itm) => itm.triviaPart, [order]);
        break;

      default:
        libs = orderBy(libs, (itm) => itm[key], [order]);
        break;
    }
    setLibraryQuestions(libs);
  };

  useEffect(() => {
    if (sortParams) {
      handleSortChange(sortParams.sortBy, sortParams.sortOrder);
    }
  }, [sortParams]);

  const tableCols = {
    question: 4,
    createdOn: 3,
    triviaPart: 2,
    action: 1,
    rating: 2,
  };

  const tableColsMobile = {
    createdOn: 5,
    triviaPart: 3,
    action: 2,
    rating: 2,
  };

  const renderRowOptions = (item) => {
    return (
      <div className="cursor-pointer">
        <span
          id={`surveyLibraryListRow_${item._id}`}
          onClick={(e) => {
            e.stopPropagation();
            setOptionsPopoverOpen(item._id);
          }}
          className="cursor-pointer ml-4"
        >
          <BsThreeDots />
        </span>

        <Popover
          isOpen={optionsPopoverOpen == item._id}
          target={`surveyLibraryListRow_${item._id}`}
          toggle={() => setOptionsPopoverOpen(null)}
          placement="bottom"
          hideArrow
          className="surveyListRow_Popover"
        >
          <PopoverBody className="">
            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                setLibQuestionEdit(item);
              }}
            >
              <BiEditAlt className="mr-3" /> Edit
            </div>
            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                setLibQuestionDelete(item);
              }}
            >
              <BiTrashAlt className="mr-3" /> Delete
            </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  };

  const editQuestion = (questionData) => {
    const {
      questionType,
      questionText,
      options,
      answer,
      linearNumericConfigs,
      _id,
      rating,
    } = questionData;

    const payload = {
      questionId: questionData._id,
      question_text: questionText,
      options: options,
      answer: answer,
      linearNumericConfigs: linearNumericConfigs,
      rating: rating,
    };

    axios
      .post(url.editLibraryQuestion, payload)
      .then(({ data }) => {
        onEditSuccess(data.data);
      })
      .catch((error) => {
        let errorMsg = WEB_GENERATE_ERROR_MESSAGE.replace(
          "trivvy",
          "questions"
        );
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {
          errorMsg = error.response.data.errors.message;
        }

        toastContainer(errorMsg, "error");
      });
  };

  const renderRating = (question) => {
    return (
      <div className="cursor-pointer d-flex justify-content-center pl-3 align-items-center">
        <span>
          {question.rating === 1 ? (
            <BsHandThumbsUpFill size={18} className="ml-1" color="#ff4500" />
          ) : (
            <BsHandThumbsUp
              onClick={(e) => {
                e.stopPropagation()
                editQuestion({
                  ...question,
                  rating: 1,
                });
              }}
              size={18}
              className="ml-1"
              color="#ff4500"
            />
          )}
          {question.rating === 0 ? (
            <BsHandThumbsDownFill size={18} className="ml-2" color="#ff4500" />
          ) : (
            <BsHandThumbsDown
              onClick={(e) => {
                e.stopPropagation()
                editQuestion({
                  ...question,
                  rating: 0,
                });
              }}
              size={18}
              className="ml-2"
              color="#ff4500"
            />
          )}
        </span>
      </div>
    );
  };

  return (
    <div>
      {questionGenerateModal && (
        <LibraryQuestionGenerateModal
          generateCall={generateQuestionsApiCall}
          open={questionGenerateModal}
          onClose={() => setQuestionGenerateModal(false)}
          library={library}
        />
      )}
      {libQuestionEdit && (
        <LibraryQuestionEditModal
          onEditSuccess={onEditSuccess}
          open={libQuestionEdit && libQuestionEdit._id != null}
          onClose={() => setLibQuestionEdit(null)}
          library={library}
          questionObject={libQuestionEdit}
        />
      )}
      {libQuestionDelete && (
        <DeleteQuestionModal
          onDelete={onDelete}
          open={libQuestionDelete && libQuestionDelete._id != null}
          onClose={() => setLibQuestionDelete(null)}
          library={library}
          question={libQuestionDelete}
        />
      )}

      {scheduleQuestionsModal && (
        <ScheduleQuestionsModal
          onClose={() => {
            setScheduleQuestionsModal(false);
          }}
          embeddedInTrivvyCreateModal={false}
          open={scheduleQuestionsModal}
          allQuestions={libraryQuestions.filter((x) => !x.triviaPart)}
          library={library}
          onScheduleSuccess={onScheduleSuccess}
          closeScheduleAndOpenGenerateModal={() => {
            setQuestionGenerateModal(true);
            setScheduleQuestionsModal(false);
          }}
          goToTrivvyTab={() =>
            props.history.push(
              `/home/trivia/${user.profile.organizationId._id}/library-item/${library._id}/view/trivvys`
            )
          }
        />
      )}
      <Row  className={!isMobile ? "trivia_edit_ui_height_wrapper mx-0 px-0":""}>
        <SidebarComponent
          library={library}
          libraryQuestions={libraryQuestions}
        />

        <Col sm={10} className="px-3 center-main-trivia-ui">
          <div className={!isMobile ?"m-5":"m-1"}>
            <div className={isMobile ?"d-flex":""}>
              {/* <Button
                style={{ height: !isMobile? "35px":"30px",whiteSpace:"pre",padding:isMobile?"3px 5px":"5px 8px" }}
                className="trivia-action-button-main"
                onClick={() => setQuestionGenerateModal(true)}
              >
                <MdOutlineAutoAwesome /> Generate Questions
              </Button> */}
              <Button
                onClick={() => {
                  setScheduleQuestionsModal(true);
                }}
                // className="ml-3 trivia-schedule-btn"
                className="trivia-action-button-main"
                // color="primary"
                style={{ height: !isMobile? "35px":"30px",whiteSpace:"pre",padding:isMobile?"3px 5px":"5px 8px",fontSize:"14px" }}
              >
                <MdSchedule />
                Schedule Trivvys
              </Button>
            </div>

            <div className="mt-5">
              <div>
                {!isMobile ? (
                  <div className="trivia_survey_list_table px-3 trivia_survey_library_table">
                    <div className="my-4 trivia_survey_list_table_contents ">
                      <LayoutRowShadow className="row-shadow-header-no-shadow mx-0">
                        <LayoutHeadingShadowLeft
                          className={"text-left"}
                          colWidth={tableCols.question}
                        >
                          Question {sortComponent("question")}
                        </LayoutHeadingShadowLeft>

                        <LayoutHeadingShadow
                          className={"text-center"}
                          colWidth={tableCols.rating}
                        >
                          Rating {sortComponent("rating")}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={"text-center"}
                          colWidth={tableCols.createdOn}
                        >
                          Date Created {sortComponent("createdOn")}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={"text-center"}
                          colWidth={tableCols.triviaPart}
                        >
                          Trivvy Part {sortComponent("triviaPart")}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={"justify-content-center"}
                          colWidth={tableCols.action}
                        ></LayoutHeadingShadow>
                      </LayoutRowShadow>
                      <div
                        className={`trivia_survey_list_table_contents_scroll ${
                          libraryQuestions.length == 0
                            ? "trivvy-no-results"
                            : ""
                        }`}
                      >
                        {!isMobile && libraryQuestions.length > 0 ? (
                          libraryQuestions.map((item, idx) => {
                            return (
                              <LayoutRowShadow
                                className="cursor-pointer"
                                key={idx}
                                onMouseEnter={() => {
                                  setHoveredQuestion(item._id);
                                }}
                                onMouseLeave={() => {
                                  setHoveredQuestion(null);
                                }}
                                onClick={() => {
                                  setLibQuestionEdit(item);
                                }}
                              >
                                <LayoutData
                                  className="text-center word-break-lib"
                                  colWidth={tableCols.question}
                                >
                                  <div className="survey-item-title h50-minCenter">
                                    {contvertHTMLToPlain(item.questionText)}
                                  </div>
                                </LayoutData>
                                {item.loading ? (
                                  <LayoutData colWidth={7}>
                                    <div className="text-center">
                                      {" "}
                                      <img
                                        src={Spinner}
                                        height="25px"
                                        width={"25px"}
                                        colWidth={tableCols.uploadDate}
                                      />{" "}
                                    </div>
                                  </LayoutData>
                                ) : (
                                  <If condition={true}>
                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.rating}
                                    >
                                      {renderRating(item)}
                                    </LayoutData>
                                    <LayoutData
                                      colWidth={tableCols.createdOn}
                                      className="cursor-pointer"
                                    >
                                      {moment(item.createdOn).format(
                                        "h:mma on MMM D, YYYY"
                                      )}
                                      <ReactTooltip />
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.triviaPart}
                                    >
                                      {hoveredQuestion == item._id &&
                                      item.triviaPart > 0 ? (
                                        <Button
                                          data-tip="View part Trivvy"
                                          onClick={() => {
                                            props.history.push(
                                              `/home/trivia/${user.profile.organizationId._id}/edit/${item.triviaPartId}/edit`
                                            );
                                          }}
                                          className="trivia-action-button-secondary-center"
                                        >
                                          {item.triviaPart}
                                          <ReactTooltip />
                                        </Button>
                                      ) : (
                                        <div
                                          style={{
                                            height: "35px",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          {" "}
                                          {item.triviaPart || "Not used"}{" "}
                                        </div>
                                      )}
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.action}
                                    >
                                      <div
                                        className="mx-3"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {item._id ? (
                                          renderRowOptions(item)
                                        ) : (
                                          <span
                                            className="ml-4"
                                            style={{ width: "18px" }}
                                          ></span>
                                        )}
                                      </div>
                                    </LayoutData>
                                  </If>
                                )}
                              </LayoutRowShadow>
                            );
                          })
                        ) : (
                          <span>No questions created yet</span>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="trivia_table_mobile mt-4">
                    <div className="trivia_survey_list_table_contents_scroll">
                      <Row>
                        <Col xs={5} className="px-0">
                          <Row>
                            <LayoutHeadingShadow
                              className={"justify-content-center"}
                              colWidth={12}
                            >
                              Question {sortComponent("question")}
                            </LayoutHeadingShadow>
                          </Row>

                          {libraryQuestions.length == 0 ? (
                            <Row
                              className={
                                "planning-row-mobile-height layout-row-shadow mx-0"
                              }
                            >
                              <LayoutData colWidth={12}>
                                No questions created yet
                              </LayoutData>
                            </Row>
                          ) : (
                            ""
                          )}

                          {libraryQuestions.map((item, idx) => {
                            return (
                              <Row
                                key={idx}
                                className={
                                  "planning-row-mobile-height cursor-pointer"
                                }
                                onClick={() => {
                                  setLibQuestionEdit(item);
                                }}
                              >
                                <LayoutDataLines colWidth={12} noFlex>
                                  <div>
                                    <div className="survey-item-title">
                                      <div className="survey-item-title">
                                        {contvertHTMLToPlain(item.questionText)}
                                      </div>
                                    </div>
                                    <ReactTooltip />
                                  </div>
                                </LayoutDataLines>
                              </Row>
                            );
                          })}
                        </Col>
                        <Col xs={7} className="scrollable-action-table-row">
                          <LayoutRowLines className="row-scroll-width-s">
                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.rating}
                            >
                              Rating {sortComponent("rating")}
                            </LayoutHeadingShadow>
                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.createdOn}
                            >
                              Date Created {sortComponent("createdOn")}
                            </LayoutHeadingShadow>
                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.triviaPart}
                            >
                              Trivvy Part {sortComponent("triviaPart")}
                            </LayoutHeadingShadow>

                            <LayoutHeadingShadow
                              className={"justify-content-center "}
                              colWidth={tableColsMobile.action}
                            ></LayoutHeadingShadow>
                          </LayoutRowLines>

                          {libraryQuestions.map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={`pl-tasks-row ${
                                  isMobile ? "row-scroll-width-s" : ""
                                }`}
                              >
                                 <LayoutDataLines
                                  className="text-center "
                                  colWidth={tableColsMobile.rating}
                                >
                                  {renderRating(item)}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center word-break-lib text-bolder f-12 text-info"
                                  colWidth={tableColsMobile.createdOn}
                                >
                                  {moment(item.createdOn).format(
                                    "h:mma on MMM D, YYYY"
                                  )}
                                </LayoutDataLines>
                               
                                <LayoutDataLines
                                  className="text-center"
                                  colWidth={tableColsMobile.triviaPart}
                                >
                                  {item.triviaPart > 0
                                    ? item.triviaPart
                                    : "Not used"}
                                </LayoutDataLines>

                                <LayoutDataLines
                                  className="text-center"
                                  colWidth={tableColsMobile.action}
                                >
                                  <div
                                    className="mx-3"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {item._id ? (
                                      renderRowOptions(item)
                                    ) : (
                                      <span
                                        className="ml-4"
                                        style={{ width: "18px" }}
                                      ></span>
                                    )}
                                  </div>
                                </LayoutDataLines>
                              </LayoutRowLines>
                            );
                          })}
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.libraryQuestionsList
        ? state.sortFilterParams.libraryQuestionsList.sort &&
          state.sortFilterParams.libraryQuestionsList.sort.hasOwnProperty(
            "sortBy"
          )
          ? state.sortFilterParams.libraryQuestionsList.sort
          : { sortBy: "", sortOrder: "" }
        : { sortBy: "", sortOrder: "" },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSortParams: (data) =>
      dispatch(actionCreators.updateLibraryQuestionSort(data)),
    updateLibraryQuestionCount: (data) =>
      dispatch(actionCreators.updateSingleLibrarayStatsForQuestionsCount(data)),
    updateLibraryTrivvyCount: (data) =>
      dispatch(actionCreators.updateSingleLibrarayStatsForTrivvyCount(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LibraryQuestions, axios));
